import {analyticsConstants} from '../../constants';

export const uploadFunctionList = (functionList) => ({
    type: analyticsConstants.UPLOAD_FUNCTION_LIST,
    functionList: functionList
});
